export class TokenAutenticazioneDTO {
    token: string;

    dataCreazione: string;

    secondiValidita: number;

    refreshToken: string;

    tipoToken: string;
}
